"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setReflectMetadata = setReflectMetadata;
function setReflectMetadata(target, metadataKey, metadata, propertyKey) {
    Reflect.defineMetadata(metadataKey, metadata, target, propertyKey);
}
//# sourceMappingURL=setReflectMetadata.js.map